import React from 'react';
import { Header } from '../components/Header';
import { NarrativeHook } from '../components/NarrativeHook';
import { ExecutiveDashboard } from '../components/ExecutiveDashboard';
import { StrategicInsights } from '../components/StrategicInsights';
import { StrategicQuestions } from '../components/StrategicQuestions';
import { CompetitiveDynamics } from '../components/CompetitiveDynamics';
import { WatchList } from '../components/WatchList';
export function Dashboard() {
  return <div className="min-h-screen bg-tech-grey-10/50 font-body text-tech-grey selection:bg-passion-red selection:text-white" data-id="element-114">
      <Header data-id="element-115" />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12" data-id="element-116">
        <NarrativeHook data-id="element-117" />
        <ExecutiveDashboard data-id="element-118" />
        <StrategicQuestions data-id="element-119" />
        <StrategicInsights data-id="element-120" />
        <CompetitiveDynamics data-id="element-121" />
        <WatchList data-id="element-122" />
      </main>

      <footer className="bg-white border-t border-tech-grey-25 py-8 mt-12" data-id="element-123">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-124">
          <p className="font-body text-sm text-tech-grey-50" data-id="element-125">
            © 2026 Wettbewerbsanalyse für Polytec.
          </p>
        </div>
      </footer>
    </div>;
}